import React, {Component} from "react"
import styles from "./Header.module.css"
import imgLogo from "./parts/img/phagans-all-logo_2.png"
import {ReactComponent as SignatureIcon} from "./parts/img/signature.svg"

interface Props {}

export class Header extends Component<Props, {}> {
    public render() {
        return (
            <header className={styles.root}>
                <div className={styles.wrapper}>
                    <h1 className={styles.h1}>
                        <img className={styles.logo} src={imgLogo} alt="phagans-logo" />
                    </h1>
                    <div className={styles.rightWrapper}>
                        {/* <SignatureIcon className={styles.signatureIcon} /> */}
                        <span className={styles.text}>Call us! 833-723-7733</span>
                        <span className={styles.textOrange}>APPLY TO PHAGANS’</span>
                    </div>
                </div>
            </header>
        )
    }
}
